import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

export const DualRangeSlider = ({ questionId, min, max, values, onChange }) => {
  const [minValue, setMinValue] = useState(min);
  const [maxValue, setMaxValue] = useState(max);

  useEffect(() => {
    setMinValue(values[0]);
    setMaxValue(values[1]);
  }, [values]);

  const handleRangeChange = ([min, max]) => {
    setMinValue(min);
    setMaxValue(max);
    onChange([min, max], questionId);
  };

  return (
    <div className="range-slider">
      <span>{minValue}</span>
      <span>{maxValue}</span>
      <Slider
        range
        min={min}
        max={max}
        value={[minValue, maxValue]}
        onChange={handleRangeChange}
      />
    </div>
  );
};
